import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';
import { IImage, Image } from './Image';
import { IntegerRange, IntegerRangeMarshaller } from './IntegerRange';
import { TeachingSkill, TeachingSkillMarshaller } from './TeachingSkill';
import { IText, Text } from './Text';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';
import { IOrganizationReference, OrganizationReference } from './OrganizationReference';

export interface ICourse extends IEntity {
  attributes: {
    id: EntityStringId
    language: Language;
    targetLevelRange: IntegerRange;
    teacherNote: string | null;
    teachingSkills: TeachingSkill[];
    visibility: string;
  };
  associations: {
    descriptionText: IText;
    image: IImage | null;
    nameText: IText;
    owner: IOrganizationReference;
  };
}

export type Course = Entity<ICourse>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Course: IEntityType<ICourse> = vmClient.defineClass({
  typeName: 'Course',
  version: 6,
  persisted: true,
  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    visibility: {
      type: 'string',
      notNull: true,
    },
    targetLevelRange: {
      type: IntegerRange,
      marshaller: IntegerRangeMarshaller,
      notNull: true,
    },
    teacherNote: 'string',
    teachingSkills: {
      collection: true,
      marshaller: TeachingSkillMarshaller,
      notNull: true,
      type: TeachingSkill,
    },
  },
  associations: {
    nameText: {
      type: Text,
      notNull: true,
    },
    descriptionText: {
      type: Text,
      notNull: true,
    },
    image: Image,
    owner: {
      type: OrganizationReference,
      notNull: true,
      shared: true,
    },
  },
});
